import Immutable from 'immutable';
import {
  CLEAR_PREVENTIVE_TASK_PROJECTIONS,
  FLAG_GETTING_PREVENTIVE_TASK_PROJECTIONS,
  GET_PREVENTIVE_TASK_PROJECTIONS,
} from '../../../actions/types/task-schedule';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.List(),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_GETTING_PREVENTIVE_TASK_PROJECTIONS:
      return state.setIn(['all', 'loading'], payload);

    case GET_PREVENTIVE_TASK_PROJECTIONS:
      return state.setIn(['all', 'content'], Immutable.List(payload || []));

    case CLEAR_PREVENTIVE_TASK_PROJECTIONS:
      return state.setIn(['all'], INITIAL_STATE.getIn(['all']));

    default:
      return state;
  }
};
